import React from "react";

const PreBoarding = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M31.122 7.272h1.194c.93 0 1.684.758 1.684 1.693V20.82c0 .935-.754 1.694-1.684 1.694h-3.369l-7.02-9.883a3.359 3.359 0 0 0-3.709-1.275l-4.185 1.263a3.356 3.356 0 0 1-3.35-.85l-.493-.495a1.7 1.7 0 0 1 .257-2.607l9.096-6.097a3.353 3.353 0 0 1 3.677-.04l6.998 4.478c.27.173.584.265.904.265ZM7.098 21.318l-2.721 2.394a1.7 1.7 0 0 0 .068 2.606l8.659 6.84a1.68 1.68 0 0 0 2.502-.491l1.186-2.086a3.401 3.401 0 0 0-.432-3.959l-4.551-5.033a3.355 3.355 0 0 0-4.71-.27Zm3.4-15.74H3.684C2.754 5.579 2 6.338 2 7.273v12.727a3.4 3.4 0 0 0 .59 1.915 4.54 4.54 0 0 1 .123-.113l2.722-2.394a5.872 5.872 0 0 1 8.243.473l4.551 5.034a5.952 5.952 0 0 1 .756 6.927l-1.102 1.94c.948.36 2.028.279 2.928-.264l7.426-4.48a1.699 1.699 0 0 0 .504-2.435l-8.87-12.495a.84.84 0 0 0-.927-.32l-4.186 1.263a5.872 5.872 0 0 1-5.862-1.486l-.493-.495c-1.879-1.89-1.57-5.034.641-6.516l1.454-.974Z"
        />
    </svg>
);

export default PreBoarding;